wp.hooks.addFilter(
    "blocks.registerBlockType",
    "danone/excerpt-attributes",
    function (settings, name) {
        if (name !== "core/post-excerpt") {
            return settings;
        }

        const originalEdit = settings.edit;

        settings.edit = (props) => {
            const { attributes } = props;
            const blockProps = wp.blockEditor.useBlockProps({
                className: attributes.showQuotes ? "has-quotes" : "",
            });

            return wp.element.createElement(
                "div",
                blockProps,
                wp.element.createElement(originalEdit, props)
            );
        };

        return {
            ...settings,
            attributes: {
                ...settings.attributes,
                showQuotes: {
                    type: "boolean",
                    default: false,
                },
            },
        };
    }
);

const withExcerptQuoteControls = wp.compose.createHigherOrderComponent(
    (BlockEdit) => {
        return function (props) {
            if (props.name !== "core/post-excerpt") {
                return wp.element.createElement(BlockEdit, props);
            }

            const { attributes, setAttributes } = props;

            return wp.element.createElement(
                wp.element.Fragment,
                null,
                wp.element.createElement(BlockEdit, props),
                wp.element.createElement(
                    wp.blockEditor.InspectorControls,
                    null,
                    wp.element.createElement(
                        wp.components.PanelBody,
                        {
                            title: "Ustawienia cytatu",
                            initialOpen: true,
                        },
                        wp.element.createElement(wp.components.ToggleControl, {
                            label: "Dodaj cudzysłów",
                            checked: attributes.showQuotes,
                            onChange: (value) =>
                                setAttributes({ showQuotes: value }),
                        })
                    )
                )
            );
        };
    },
    "withExcerptQuoteControls"
);

wp.hooks.addFilter(
    "editor.BlockEdit",
    "danone/with-excerpt-quote-controls",
    withExcerptQuoteControls
);
